const peevaBlue = {
	DEFAULT: "#52BFF4",
	110: "#5dc1f3",
};

export default peevaBlue;
